import template from './template.html';

function Directive() {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template,
    controller: 'conciergeSignupCtrl'
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/conciergeSignup/index.js